export interface ShopInfo {
  name: string;
  phone: string;
  hours: string;
  address: {
    zip: string;
    line1: string;
    line2?: string;
  };
  mapUrl: string;
  reservationUrl: string;
  copyright: string;
  basePath: string;
}

const configs: Record<string, ShopInfo> = {
  miyakan: {
    name: "手もみ王 宮環駒生店",
    phone: "028-688-7822",
    hours: "10:00〜26:00（最終受付25:00）",
    address: {
      zip: "320-0065",
      line1: "栃木県宇都宮市駒生町3363-23",
    },
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3996.444071219098!2d139.8472926758283!3d36.5823143723101!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601f68a1594a8633%3A0x9dcb4e7bfdbc5a2b!2z5omL44KC44G_546LIOWurueSsOmnkueUn-W6lw!5e1!3m2!1sja!2sjp!4v1764920459995!5m2!1sja!2sjp",
    reservationUrl: "https://www.peakmanager.com/online/index/v5r2h6",
    copyright: "Temomio 2025",
    basePath: "./",
  },
  kanuki: {
    name: "手もみ王 沼津香貫店",
    phone: "055-932-3700",
    hours: "10:00〜24:30（最終受付24:00）",
    address: {
      zip: "410-0813",
      line1: "静岡県沼津市上香貫1406-1",
    },
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4072.5425811682985!2d138.8661254757613!3d35.085832672785294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60198fe88ca7e2e1%3A0x8447d73b3b04740f!2z5omL44KC44G_546LIOayvOa0pemmmeiyq-W6lw!5e1!3m2!1sja!2sjp!4v1764925137145!5m2!1sja!2sjp",
    reservationUrl: "https://www.peakmanager.com/online/index/m4t6z5",
    copyright: "Temomio 2025",
    basePath: "./",
  },
  yunoki: {
    name: "手もみ王 富士柚木店",
    phone: "0545-65-2600",
    hours: "10:00～25:30（最終受付25:00）",
    address: {
      zip: "416-0908",
      line1: "静岡県富士市柚木223-1",
    },
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4068.9540234731394!2d138.6378853!3d35.1576417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601bd3560bf894d5%3A0x48d702e7dfc62e4b!2z5omL44KC44G_546LIOWvjOWjq-afmuacqOW6lw!5e1!3m2!1sja!2sjp!4v1765341229694!5m2!1sja!2sjp",
    reservationUrl: "https://www.peakmanager.com/online/index/y4a6d1",
    copyright: "Temomio 2025",
    basePath: "./",
  },
};

const shop = process.env.REACT_APP_SHOP ?? "kanuki";
export const SHOP_INFO: ShopInfo = configs[shop] ?? configs.kanuki;
